import { useQuery } from '@tanstack/react-query';
import { Loader2, Plug } from 'lucide-react';
import { api } from '@/api/client';

interface Channel {
  id: number;
  type: string;
  name?: string;
  storeUrl?: string;
  isActive?: boolean;
  lastSyncAt?: string;
}

export function MerchantChannelsTab({ merchantId }: { merchantId: number }) {
  const { data, isLoading } = useQuery({
    queryKey: ['merchant-channels', merchantId],
    queryFn: async () => (await api.get<Channel[]>(`/merchants/${merchantId}/channels`)).data,
  });

  if (isLoading) return <div className="flex justify-center py-8"><Loader2 size={20} className="animate-spin text-primary" /></div>;
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400">
        <Plug size={24} className="mx-auto mb-2 opacity-50" />
        <p className="text-sm">No sales channels connected.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {data.map((ch) => (
        <div key={ch.id} className="flex items-center justify-between p-3 border border-slate-200 rounded-lg">
          <div>
            <div className="font-medium text-slate-900">{ch.name ?? ch.type}</div>
            {ch.storeUrl && <div className="text-xs text-slate-500 truncate max-w-xs">{ch.storeUrl}</div>}
            {ch.lastSyncAt && <div className="text-xs text-slate-400">Last sync: {new Date(ch.lastSyncAt).toLocaleString('en-IN')}</div>}
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs bg-slate-100 px-2 py-0.5 rounded font-mono">{ch.type}</span>
            <span className={`text-xs font-medium ${ch.isActive ? 'text-success' : 'text-slate-400'}`}>
              {ch.isActive ? '● Active' : '○ Disabled'}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
